import { Controller } from "@hotwired/stimulus";
import { gsap } from "gsap/all";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class extends Controller {
  static targets = ["image", "content"];

  connect() {
    requestAnimationFrame(() => this._setupParallax());
  }

  disconnect() {
    this.scrollTriggerInstance?.kill();
  }

  _setupParallax() {
    if (!this.hasImageTarget || !this.hasContentTarget) return;

    if (window.innerWidth < 1024) return;

    gsap.set([this.imageTarget, this.contentTarget], {
      willChange: "transform, opacity, filter",
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.element,
        start: "top top",
        end: "bottom top",
        scrub: 0.5,
      },
    });

    // --- ANIMATION IMAGE ---
    tl.fromTo(
      this.imageTarget,
      {
        yPercent: -15,
        scale: 1.1,
        filter: "blur(0px)",
      },
      {
        yPercent: 0,
        scale: 1,
        ease: "none",
        filter: "blur(5px)",
        duration: 1,
      },
      0
    );

    // --- ANIMATION CONTENU ---
    tl.fromTo(
      this.contentTarget,
      {
        yPercent: 0,
        autoAlpha: 1,
      },
      {
        yPercent: -40,
        autoAlpha: 0,
        ease: "power1.out",
        duration: 0.4,
      },
      0
    );

    this.scrollTriggerInstance = tl.scrollTrigger;
  }
}
